export default __webpack_public_path__ + "static/media/emoji_events.5ed350d6.svg";